import React from "react";
import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from "recharts";
import {
  ChartConfig,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";

interface BarChartComponentProps {
  data: any[];
  config: ChartConfig;
}

export const BarChartComponent: React.FC<BarChartComponentProps> = ({
  data,
  config,
}) => {
  return (
    <BarChart data={data} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
      <CartesianGrid
        vertical={false}
        className="stroke-border dark:stroke-gray-600"
      />
      <YAxis
        tickLine={false}
        axisLine={false}
        width={40}
        className="text-text-tertiary dark:text-gray-400"
        allowDecimals={false}
        tickFormatter={(value: number) =>
          value >= 1000 ? `${Math.round(value / 1000)}k` : `${value}`
        }
      />
      <XAxis
        dataKey="date"
        tickLine={false}
        axisLine={false}
        tickMargin={8}
        minTickGap={32}
        className="text-text-tertiary dark:text-gray-400"
        tickFormatter={(value) => {
          const date = new Date(value);
          return date.toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
          });
        }}
      />
      <ChartTooltip
        cursor={false}
        content={
          <ChartTooltipContent
            labelFormatter={(value) => {
              return new Date(value).toLocaleDateString("en-US", {
                month: "short",
                day: "numeric",
                year: "numeric",
              });
            }}
            indicator="dot"
          />
        }
      />
      {Object.keys(config).map((key, index) => (
        <Bar
          key={key}
          dataKey={key}
          stackId="a"
          fill={config[key].color}
          radius={
            index === Object.keys(config).length - 1
              ? [4, 4, 0, 0] // Top bar - rounded bottom
              : [0, 0, 0, 0] // Middle bars - no rounding
          }
        />
      ))}
      <ChartLegend content={<ChartLegendContent payload={[]} />} />
    </BarChart>
  );
};
